'use client';

import { useIntl } from 'react-intl';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { ProductCardGridItem } from '@packages/modules/src/ProductCardV2/ProductCardV2.GridItem.client';
import { messages } from './messages';

export type RecoConsentToolCardProps = {
  onActivate: () => void;
};

export const RecoConsentToolCard = ({ onActivate }: RecoConsentToolCardProps) => {
  const { formatMessage } = useIntl();

  return (
    <ProductCardGridItem
      id="RecoConsentToolCard"
      className="bg-color-background-base mb-0 block [&>:last-child]:mb-0.5 lg:[&>:last-child]:mb-1"
    >
      <div className="flex flex-col justify-start gap-3 p-1.5">
        <div className="flex flex-col gap-1.5">
          <div>
            <span className="icon-emp-legals-cookie size-[2.625rem]" />
          </div>
          <div>
            <p className="text-size-body-sm text-color-text-dark">
              {formatMessage(messages.title)}
            </p>
          </div>
          <div>
            <p className="text-size-body-sm text-color-text-dark">
              {formatMessage(messages.description)}
            </p>
          </div>
        </div>
        <div>
          <Button className="text-size-body-xs h-5 w-full leading-2" onClick={onActivate}>
            {formatMessage(messages.buttonTitle)}
          </Button>
        </div>
      </div>
    </ProductCardGridItem>
  );
};
